/* eslint-disable prettier/prettier */
<template>
  <div>
    <!-- Form section -->
    <v-row>
      <v-col cols="4" v-for="(item, i) in form" :key="i">
        <v-text-field
          :label="item.label"
          v-model="item.value"
          outlined
          :rules="item.rules"
          dense
          :type="item.type"
          :disabled="item.disabled"
          :max="item.counter"
          :counter="item.counter"
          @input="input"
        ></v-text-field>
      </v-col>
    </v-row>
    
    <!-- Scrollable Card for localRecord -->
    <div
      :style="{
        position: 'fixed',
        top: '16px',
        right: tempRecord.length > 0 ? '332px' : '16px',
        width: '300px',
        maxHeight: '400px',
        overflowY: 'auto',
        zIndex: 100
      }"
      v-show="localRecord.length > 0"
    >
      <v-card outlined elevation="3">
         <v-card-title class="text-h6 d-flex align-center">
        <!-- Local Records -->
         <span style="color: #f1ba03;">Local Records</span>
        <v-spacer />
        <v-btn icon @click="expanded = !expanded">
          <v-icon>{{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
        </v-btn>
      </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-show="expanded">
          <div v-for="(item, i) in localRecord" :key="i" class="mb-2">
            <v-chip color="#f1ba03" text-color="black" outlined @click="handleChipClick(item.uId)">
              {{item.oldName || item.name}} | {{ item.status}} | {{  item.updatedBy  }} 
            </v-chip>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <!-- Scrollable Card for tempRecord -->
    <div
      style="
        position: fixed;
        top: 16px;
        right: 16px;
        width: 300px;
        max-height: 400px;
        overflow-y: auto;
        z-index: 1000;
      "
      v-show="tempRecord.length > 0"
    >
      <v-card outlined elevation="3">
      <v-card-title class="text-h6 d-flex align-center">
        Temp Records
        <v-spacer />
        <v-btn icon @click="expandedTemp = !expandedTemp">
          <v-icon>{{ expandedTemp ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
        </v-btn>
      </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-show="expandedTemp">
          <div v-for="(item, i) in tempRecord" :key="i" class="mb-2">
            <v-chip color="primary" text-color="black" outlined>
              {{ item.data.name }} | {{ item.status }} | {{  item.updatedBy }} 
            </v-chip>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <v-card outlined>
      <v-card-text class="mb-0 pb-0">
        <v-form v-model="isValid" ref="form">
          <v-row>
            <v-col cols="12" sm="2" class="py-0">
              <v-autocomplete
                label="Year From"
                outlined
                dense
                :rules="field"
                v-model.trim="model.from"
                :items="years"
                type="number"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2" class="py-0">
              <v-autocomplete
                label="Year To"
                outlined
                v-model.trim="model.to"
                dense
                :rules="yearTo"
                :items="years"
                type="number"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="8"
              class="d-flex py-0"
              :class="$root.isMobile ? 'flex-column' : ''"
            >
              <v-text-field
                v-model.trim="model.name"
                :rules="rules"
                label="Type model name and hit Add Model button"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
            <v-col cols="4" class="py-0">
              <v-text-field
                label="KEY CATEGORY POP UP"
                outlined
                hide-details
                dense
                v-model="model.key_category"
                readonly
              />
            </v-col>
            <v-col cols="4" class="py-0">
              <v-text-field
                hide-details
                label="APPLICABLE ITEM NUMBER(S)"
                outlined
                dense
                v-model="model.app_item_no"
                readonly
                :class="index !== -1 && model.stock > 0 ? 'app-item-selected' : ''"
                :background-color="index !== -1 && model.stock > 0 ? '#c8f7c5' : ''"
              />
            </v-col>
            <v-col cols="4" class="py-0">
              <v-select
                v-if="typeOfKeyField"
                outlined
                dense
                hide-details
                item-text="name"
                item-value="name"
                :items="typeOfKeyField.options || []"
                clearable
                :label="typeOfKeyField.name"
                v-model="model.type_of_key"
              />
            </v-col>
            <v-col cols="4" class="py-3">
  <div
    class="d-flex align-center success-checkbox-wrapper"
    :class="{ 'success-border': isAdditionalFieldsComplete }"
  >
    <v-checkbox
      v-model="showModal"
      label="Add additional fields"
      dense
      class="ma-0 pa-0"
      hide-details
    ></v-checkbox>

    <v-icon
      v-if="isAdditionalFieldsComplete"
      color="green"
      small
      class="ml-2"
    >
      mdi-check-circle
    </v-icon>
  </div>
</v-col>

            

            <v-col cols="4" class="py-3">
            </v-col>
          </v-row>

          <v-dialog v-model="showModal" persistent max-width="900px">
            <v-card class="pa-4" outlined>
              <v-row>
                <v-col>
                  <v-card-title class="headline text-center">
                    Add Additional Fields
                  </v-card-title>
                </v-col>
                <v-col cols="2" class="py-3">
                  <v-card-actions class="justify-end">
                  <v-btn
                    depressed
                    tile
                    outlined
                    color="primary"
                    :class="$root.isMobile ? 'mt-3' : 'ml-3'"
                    :width="$root.isMobile ? '100%' : '140px'"                    @click="showModal = false; saveModalFields()"
                  >
                    Close
                  </v-btn>
              </v-card-actions>
                </v-col>
              </v-row>
              
              
              <v-card-text>
                <v-row>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="ITEM #"
                      outlined
                      dense
                      v-model="model.item_number"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="MFG"
                    outlined
                    dense
                    v-model="model.mfg"
                    :items="mfgOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      readonly
                      clearable
                      label="KEY CATEGORY POP UP"
                      :value="model.key_category"
                      append-icon="mdi-checkbox-marked-outline"
                      class="no-bottom-class"
                      @click="keyCategoryDialog = true"
                      @click:append="keyCategoryDialog = true"
                      @click:clear="model.key_category = null"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CHIP ID"
                      outlined
                      dense
                      v-model="model.chipId"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                  label="FCC" outlined dense v-model="model.fcc" />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-input hide-details dense class="d-flex align-center">
                      <v-text-field hide-details outlined dense :value="(model.mechanical_key || '')
                        .replace(/N\/A/gi, '__NA__')
                        .replace(/\//g, ' - ')
                        .replace(/__NA__/g, 'N/A')" label="MECHANICAL KEY & INSERT BLADE" class="custom-field"
                        @input="val => model.mechanical_key = val" />
                      <v-text-field hide-details outlined dense @input="val => model.emg_key = val" :value="(model.emg_key || '')
                        .replace(/N\/A/gi, '__NA__')
                        .replace(/\//g, ' - ')
                        .replace(/__NA__/g, 'N/A')"  />
                    </v-input>
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field hide-details
                      label="OEM PART #"
                      outlined
                      dense
                      v-model="model.oem"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IC"
                      outlined
                      dense
                      v-model="model.ic"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CODE SERIES"
                      outlined
                      dense
                      v-model="model.code_series"
                    />
                  </v-col>

                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="BRAND"
                    outlined
                    dense
                    v-model="model.brand"
                    :items="brandOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="CONDITION"
                    outlined
                    dense
                    v-model="model.condition"
                    :items="conditionOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="PRICE$"
                      outlined
                      dense
                      v-model="model.price"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="LISHI"
                    outlined
                    dense
                    v-model="model.lishi"
                    :items="lishiOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="FREQUENCY"
                    outlined
                    dense
                    v-model="model.frequency"
                    :items="frequencyOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="TRANSPONDER TYPE"
                      outlined
                      dense
                      v-model="model.transponderType"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="BTN CONFIG"
                      outlined
                      dense
                      v-model="model.btn_config"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-select 
                    label="# BUTTONS"
                    outlined
                    hide-details
                    dense
                    v-model="model.button"
                    :items="buttonOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="BATTERY TYPE"
                    outlined
                    dense
                    v-model="model.battery_type"
                    :items="batteryOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>   
                  <v-col cols="4" class="py-3">
                    <v-select 
                      label="TOTAL TOKENS"
                      outlined
                      hide-details
                      dense
                      v-model="model.tokensNeed"
                      :items="totalTokensOptions"
                      item-text="value"
                      item-value="value"
                      clearable
                    />
                  </v-col> 
                  <v-col cols="4" class="py-3">
                    <v-select
                    label="PIN CODE REQUIRED"
                    outlined
                    hide-details
                    dense
                    v-model="model.pinCode"
                    :items="pinCodeOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="RE-FLASHING-(AKL)"
                    outlined
                    dense
                    v-model="model.reFlashing"
                    :items="reflashingOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="REUSABLE"
                    outlined
                    dense
                    v-model="model.reusable"
                    :items="reusableOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="CLONEABLE"
                    outlined
                    dense
                    v-model="model.cloneable"
                    :items="cloneableOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3" no-bottom-space>
                    <v-select 
                    label="ADDITIONAL HARDWARE REQUIRED"
                    outlined
                    dense
                    v-model="model.additionalHardware"
                    :items="additionalHardwareOptions"
                    item-text="value"
                    item-value="value"
                    clearable
                    hide-details
                    class="no-bottom-class"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-select 
                      label="PROGRAM REMOTE"
                      outlined
                      hide-details
                      dense
                      v-model="model.programRemote"
                      :items="programRemoteOptions"
                      item-text="value"
                      item-value="value"
                      clearable
                    />
                  </v-col>

                  <v-col cols="4" class="py-3">
                    <v-select
                      label="ADD A KEY"
                      outlined
                      hide-details
                      dense
                      v-model="model.addKey"
                      :items="addKeyOptions"
                      item-text="value"
                      item-value="value"
                      clearable

                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER SYSTEM"
                      outlined
                      dense
                      v-model="model.immobiliserSystem"
                    />
                  </v-col> 
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER CABLE"
                      outlined
                      dense
                      v-model="model.immobiliserCable"
                    />
                  </v-col> 
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER SOFTWARE"
                      outlined
                      dense
                      v-model="model.immobiliserSoftware"
                    />
                  </v-col> 
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="REMOTE SYSTEM"
                      outlined
                      dense
                      v-model="model.remoteSystem"
                    />
                  </v-col> 
                  
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="DRAWER"
                      outlined
                      dense
                      v-model="model.drawer"
                    />
                  </v-col>                 
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="SLOT"
                      outlined
                      dense
                      v-model="model.slot"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3 d-flex align-center">
                    <v-btn icon small @click="model.stock = Math.max(0, model.stock - 1)">
                      
                    <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <v-text-field
                      hide-details
                      label="STOCK"
                      outlined
                      dense
                      type="number"
                      v-model.number="model.stock"
                      
                    />

                    <v-btn icon small @click="model.stock++">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-col>
                  
                  <v-col cols="6" class="py-3">
                    <v-textarea
                      label="FITS"
                      outlined
                      dense
                      v-model="model.fits"
                      class="custom-textarea"
                    ></v-textarea>
                  </v-col>

                  <v-col cols="6" class="py-3">
                    <v-textarea
                      label="NOTE"
                      outlined
                      dense
                      v-model="model.notes"
                      class="custom-textarea"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row v-for="(dataEntry, index) in combinedDataEntryLogs.slice(0,10)" :key="index">
                  <h3>
                  {{ 
                  "" + dataEntry.name + 
                  "   |   " + dataEntry.action +
                  "   |   " + new Date(dataEntry.timeStamp).toLocaleDateString('en-US', {timeZone : 'America/Los_Angeles'})
                  + "   |   " + new Date(dataEntry.timeStamp).toLocaleTimeString('en-US', {timeZone : 'America/Los_Angeles'})
                  }}
                  </h3>
                </v-row>

              </v-card-text>
              <v-card-actions class="justify-end">
                <!-- <v-btn 
                depressed
                tile 
                @click="showModal = false; saveModalFields()" class="mr-2 pl-10 pr-10 primary" >
                  Save
                </v-btn> -->
                <v-btn
                    depressed
                    tile
                    outlined
                    color="primary"
                    :class="$root.isMobile ? 'mt-3' : 'ml-3'"
                    :width="$root.isMobile ? '100%' : '140px'"                    @click="showModal = false; saveModalFields()"
                  >
                    Close
                  </v-btn>
                <!-- <v-btn
                  text
                  color="primary"
                  @click="saveModalFields"
                >
                  Save
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-row class="mt-3">
            <v-col cols="4" sm="4">
              <v-text-field
                v-model.trim="model.lostCarKey"
                :rules="[]"
                type="number"
                label="Lost Car Key"
                outlined
                dense
                prepend-inner-icon="mdi-currency-usd"
                @input="onLostCarKeyInput"
              >
              </v-text-field>
            </v-col>
            <v-col v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher" cols="8" class="text-right">
              <v-btn
                :class="$root.isMobile ? 'mb-4' : 'ml-4'"
                v-if="index == -1"
                outlined
                height="40px"
                tile
                @click="add()"
              >
                <v-icon left>mdi-plus</v-icon>
                Add Model
              </v-btn>
              
              <v-btn
                v-else
                class="ml-4"
                outlined
                height="40px"
                @click="update()"
              >
                Update Model
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <!-- Data Table Section -->
    <v-card outlined flat tile class="mt-5">
      <v-data-table 
        :headers="headers"
        class="templates-table"
         :item-class="getRowClass"
        :items="filteredList"
      >
        <template v-slot:top>
          <div class="pa-5 pb-0">
            <v-combobox
              v-model="searchChips"
              label="Search Model"
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              multiple
              chips
              append-icon=""
              clearable
              hide-no-data
            >
              <template v-slot:selection="{ item , index }">
                <label
                  class="tag-item"
                >
                <span class="chip-title">
                  {{ item }}
                </span>
                  <span
                    class="clear-btn"
                    @click.stop="searchChips.splice(index, 1)"
                  >
                    ×
                  </span>
                </label>
              </template>
            </v-combobox>
            <v-row class="mb-2">
              <v-col cols="6" md="2">
                <v-autocomplete
                  v-model="filterFrom"
                  :items="filteredFromYears"
                  label="From Year"
                  dense
                  outlined
                  clearable
                  hide-details
                />
              </v-col>
              <v-col cols="6" sm="2">
                <v-checkbox
                  v-model="exactFrom"
                  label="Exact"
                  dense
                  hide-details
                  class="mt-1"
                />
              </v-col>

              <v-col cols="6" md="2">
                <v-autocomplete
                  v-model="filterTo"
                  :items="filteredToYears"
                  label="To Year"
                  dense
                  outlined
                  clearable
                  hide-details
                />
              </v-col>
              <v-col cols="6" sm="2">
                <v-checkbox
                  v-model="exactTo"
                  label="Exact"
                  dense
                  hide-details
                  class="mt-1"
                />
              </v-col>
              <v-col cols="12" md="4" class="text-right">
                <v-btn tile color="warn" style="margin-bottom: 10px;" @click="clearFilters">
                  <v-icon left>mdi-close</v-icon>
                  <slot>Clear Filters</slot>
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>
        <template
         v-slot:item.status="{item}">
          <v-icon
          v-if="item.status"
          color="green"
          small
          class="ml-2"
        >
          mdi-check-circle
        </v-icon>
        <v-icon
          v-else
          color="red"
          small
          class="ml-2"
        >
          mdi-check-circle
        </v-icon>
        <v-icon
          v-if="modifedRecordID.includes(item.uId)"
          color="yellow"
          small
          class="ml-2"
        >
          mdi-check-circle
        </v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <edit-icon-button
            @click="openEdit(item, item.index)"
          ></edit-icon-button>
          <v-btn v-if="isAdmin" icon @click="remove(item.index)" color="red"> 
            <!-- need to update -->
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn small icon :disabled="duplicatingUIds.includes(item.uId)" @click="duplicate(item)">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  <!-- Key Category picker dialog -->
  <v-dialog v-model="keyCategoryDialog" max-width="620" scrollable>
      <v-card>
        <v-card-title class="pb-0">
          Select Key Category
        </v-card-title>

        <v-card-text class="pt-3 pb-1">
          <div
            class="key-search-box"
            @click="focusKeySearch"
          >
            <v-icon small color="grey darken-1" class="key-search-icon">mdi-magnify</v-icon>

            <v-chip
              v-for="(term, index) in committedKeyCategorySearchChips"
              :key="`search-${term}-${index}`"
              color="primary"
              text-color="white"
              x-small
              label
              class="key-chip"
            >
              {{ term }}
              <v-icon x-small @click.stop="removeCommittedKeyCategorySearchChip(index)">mdi-close</v-icon>
            </v-chip>

            <v-chip
              v-for="(chip, index) in keyCategoryChips"
              :key="index"
              color="primary"
              text-color="white"
              x-small
              label
              class="key-chip"
            >
              {{ chip.name || chip.value || chip }}
              <v-icon x-small @click.stop="removeKeyCategoryChip(index)">mdi-close</v-icon>
            </v-chip>

            <input
              ref="keyCategoryInput"
              v-model="pendingKeyCategorySearch"
              class="key-search-input"
              :placeholder="committedKeyCategorySearchChips.length || keyCategoryChips.length ? '' : 'Type or select, then press Enter to add...'"
              @keydown.enter.prevent="commitKeyCategorySearch"
              @keydown.backspace="handleKeyCategoryBackspace"
              @input="onKeyCategoryTextInput"
            />

            <v-icon
              small
              color="grey darken-1"
              class="key-search-copy"
              title="Copy"
              @click.stop="copyKeySearchContent"
            >
              mdi-content-copy
            </v-icon>
          </div>
        </v-card-text>

        <v-card-text
          class="pt-2 pb-1"
          style="max-height:340px;overflow-y:auto;"
        >
          <v-list dense>
            <v-list-item
              v-for="opt in filteredKeyCategoryOptions"
              :key="opt.value"
              @click="selectKeyCategoryOption(opt)"
              :class="keyCategoryChips.some(chip => (chip.value || chip) === opt.value) ? 'primary--text key-option-selected' : ''"
            >
              <v-list-item-action class="my-0 mr-2">
                <v-checkbox
                  :input-value="keyCategoryChips.some(chip => (chip.value || chip) === opt.value)"
                  color="primary"
                  hide-details
                  class="ma-0 pa-0"
                  readonly
                  @click.stop="selectKeyCategoryOption(opt)"
                />
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title
                  style="
                    white-space: normal;
                    overflow: visible;
                    text-overflow: unset;
                    word-break: break-word;
                    line-height:1.4;
                    font-size: 18px;
                  "
                >
                  {{ opt.name || opt.value }}
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-action class="my-0 ml-2">
                <v-icon
                  small
                  color="grey darken-1"
                  title="Copy"
                  @click.stop="copyKeyCategoryOption(opt)"
                >
                  mdi-content-copy
                </v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item
              v-if="filteredKeyCategoryOptions.length === 0"
              disabled
            >
              <v-list-item-title class="grey--text">
                No results
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-btn
            text
            color="grey"
            @click="cancelKeyCategory"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            text
            color="primary"
            :disabled="keyCategoryChips.length === 0"
            @click="selectKeyCategory"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import customerModal from "../../../assets/js/customer.modal";
import EditIconButton from "../../buttons/EditIconButton.vue";
import { auth, tempModels, localUpdates, fs, carMake} from "../../../assets/js/firebase";
import fieldsId from "../../../assets/constants/additonal.fields.constant";
import stringSimilarity from 'string-similarity';
import { EventBus } from "../../../main";
import uuidv4 from 'uuid/v4'; 
import { getDate } from "../../../assets/js/common";
import { errorLogsWrapper } from "../../../assets/js/errorLogsWrapper";
import { writeDataEntryLog, fetchCombinedDataEntryLogs } from "../../../assets/js/dataEntryLogsService";

const defaultForm = {
  name: "",
  from: "",
  to: "",
  key_category: "",
  app_item_no: "",
  type_of_key: "",
  lostCarKey: 0.00,
  fcc: '',
  code_series: '',
  item_number: '',
  ic: '',
  mechanical_key: ' ',
  emg_key : '',
  mfg: '',
  oem: '',
  drawer: '',
  chipId: '',
  battery_type: '',
  slot: '',
  btn_config: '',
  condition: '',
  stock: 0,
  frequency: '',
  lishi: '',
  button : '',
  onboardProgramming : '',
  fits: '',
  notes : '',
  pinCode : '',
  addKey : '',
  programRemote: '',
  reFlashing : '',
  immobiliserSystem : '',
  tokensNeed : '',
  reusable : '',
  cloneable : '',
  remoteSystem : '',
  immobiliserSoftware : '',
  immobiliserCable : '',
  additionalHardware : '',
  transponderType : '',
  price : '',
  brand : '',
 // dataEntry : '',
  dataEntryLogs : [],
  //dataEntryList: [{name:'ramdas',date : new Date().toLocaleString(), timeStamp : Date.now()}, {name:'ramdas',date : new Date().toLocaleString(),timeStamp : Date.now()} , {name:'ramdas',date : new Date().toLocaleString(),timeStamp : Date.now()}],
};

export default {

  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  
  components: {
    EditIconButton,
  },
  data() {
    return {
      duplicatingUIds: [],
      selectedRecordIDs: [],
      expanded: true,
      expandedTemp: true,
      tempRecord:[],
      localRecord:[],
      modifedRecordID:[],
      showModal: false,
      beforeEditSnapShot : null,
      combinedDataEntryLogs: [],
      models: [],
      search: "",
      name: "",
      isValid: false,
      index: -1,
      model: {
        ...defaultForm,
      },
      mfgOptions : [],
      brandOptions : [],
      conditionOptions : [],
      reflashingOptions : [],
      batteryOptions : [],
      keyCategoryOptions : [],
      keyCategoryDialog: false,
      keyCategorySearch: '',
      pendingKeyCategorySearch: '',
      pendingKeyCategoryOption: null,
      committedKeyCategorySearchChips: [],
      keyCategoryChips: [],
      keyCategoryJustSelected: false,
      buttonOptions : [],
      totalTokensOptions : [],
      pinCodeOptions : [],
      reusableOptions : [],
      cloneableOptions : [],
      programRemoteOptions : [],
      addKeyOptions : [],
      lishiOptions : [],
      frequencyOptions : [],
      additionalHardwareOptions : [],

      rules: [
        (v) => !!v || "Field is required",
        (v) => v.length <= 255 || "Field must be less than 255 characters",
      ],
      field: [(v) => !!v || "Field is required"],
      yearTo: [
        (v) => !!v || "Field is required",
        (v) => this.model.from <= v || "Field must be more than from year",
      ],
      searchChips: [],
      filterFrom: null,
      filterTo: null,
      exactFrom: false,
      exactTo: false
    };
  },
  
  computed: {
    filteredKeyCategoryOptions() {
      try {
        const normalize = (str) => (str || "").toString().toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();

        const terms = (this.committedKeyCategorySearchChips || [])
          .map(term => term.toString().toLowerCase().trim())
          .filter(Boolean);
        let list = [...(this.keyCategoryOptions || [])];

        if (terms.length) {
          const wordGroups = terms.map(term => normalize(term).split(" ").filter(Boolean));

          list = list.filter(item => {
            const name = (item.name || "").toLowerCase();
            const value = (item.value || "").toLowerCase();
            const normalizedName = normalize(item.name);
            const normalizedValue = normalize(item.value);

            return terms.every((term, i) => {
              if (name.includes(term) || value.includes(term)) return true;
              const words = wordGroups[i];
              if (!words.length) return false;
              return words.every(word =>
                normalizedName.includes(word) || normalizedValue.includes(word)
              );
            });
          });

          list.sort((a, b) => {
            const aName = (a.name || "").toLowerCase();
            const bName = (b.name || "").toLowerCase();
            const rank = (name) => {
              if (terms.some(term => name === term)) return 0;
              if (terms.some(term => name.startsWith(term))) return 1;
              return 2;
            };
            return rank(aName) - rank(bName);
          });
        }

        if (!this.keyCategoryChips.length) {
          return list;
        }

        const selectedValues = this.keyCategoryChips.map(chip => (chip.value || chip).toString().toLowerCase());

        return list.filter(item => selectedValues.includes((item.value || "").toString().toLowerCase()));
      } catch (e) {
        console.error('[Form.vue filteredKeyCategoryOptions] error', e);
        errorLogsWrapper({ module: 'Form.vue filteredKeyCategoryOptions', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
        return this.keyCategoryOptions || [];
      }
    },

    isAdditionalFieldsComplete() {
      try {
        const requiredFields = [
          'item_number', 'mfg', 'key_category', 'chipId', 'fcc', 'mechanical_key',
          'emg_key', 'oem', 'ic', 'code_series', 'brand', 'condition', 'price',
          'lishi', 'frequency', 'transponderType', 'btn_config', 'button',
          'battery_type', 'tokensNeed', 'pinCode', 'reFlashing', 'reusable',
          'cloneable', 'additionalHardware', 'programRemote', 'addKey',
          'immobiliserSystem', 'immobiliserCable', 'immobiliserSoftware',
          'remoteSystem', 'drawer', 'slot', 'stock', 'fits', 'notes'
        ];

        return requiredFields.every(field => {
          const value = this.model[field];
          return value !== null && value !== undefined && value !== '';
        });
      } catch (e) {
        console.error('[Form.vue isAdditionalFieldsComplete] error', e);
        errorLogsWrapper({ module: 'Form.vue isAdditionalFieldsComplete', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { modelUId: this.model?.uId }, createdBy: auth.currentUser?.email || '-' });
        return false;
      }
    },

    typeOfKeyField() {
      try {
        return this.$store.getters.serviceFields.find(
          (i) => i.id == customerModal.TYPE_OF_KEY
        );
      } catch (e) {
        console.error('[Form.vue typeOfKeyField] error', e);
        errorLogsWrapper({ module: 'Form.vue typeOfKeyField', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
        return null;
      }
    },
    
    list() {
      try {
        return [...this.models].map((i, index) => {
          const requiredFields = [
            'item_number', 'mfg', 'key_category', 'chipId', 'fcc', 'mechanical_key',
            'emg_key', 'oem', 'ic', 'code_series', 'brand', 'condition', 'price',
            'lishi', 'frequency', 'transponderType', 'btn_config', 'button',
            'battery_type', 'tokensNeed', 'pinCode', 'reFlashing', 'reusable',
            'cloneable', 'additionalHardware', 'programRemote', 'addKey',
            'immobiliserSystem', 'immobiliserCable', 'immobiliserSoftware',
            'remoteSystem', 'drawer', 'slot', 'stock', 'fits', 'notes'
          ];

          const result = requiredFields.every(field => {
            const value = i[field];
            return value !== null && value !== undefined && value !== '';
          });
          i.status = result;
          return {
            ...i,
            index,
          };
        });
      } catch (e) {
        console.error('[Form.vue list] error', e);
        errorLogsWrapper({ module: 'Form.vue list', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { modelsLength: this.models?.length }, createdBy: auth.currentUser?.email || '-' });
        return [];
      }
    },
    
    years() {
      try {
        let year = 1979;
        let list = [];
        while (year < new Date().getFullYear()) {
          year++;
          list.push(year);
        }
        return list.reverse();
      } catch (e) {
        console.error('[Form.vue years] error', e);
        errorLogsWrapper({ module: 'Form.vue years', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
        return [];
      }
    },

    isUpdate() {
      try {
        return this.$route.name === "car-make-update";
      } catch (e) {
        console.error('[Form.vue isUpdate] error', e);
        errorLogsWrapper({ module: 'Form.vue isUpdate', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
        return false;
      }
    },

    headers() {
      try {
        let headers = [
          { text: "Year From", value: "from" },
          { text: "Year To", value: "to" },
          { text: "Model", value: "name" },
          { text: "KEY CATEGORY POP UP", value: "key_category" },
          { text: "APPLICABLE ITEM NUMBER(S)", value: "app_item_no" },
          { text: "TYPE OF KEY", value: "type_of_key" },
          { text: "ADDITIONAL FIELDS ", value:"status"},
          { text: "ACTION", value: "action" },
        ];
        let list = [];
        for (let item of headers) {
          let { text, value } = item;
          let doc = {
            text: text.toUpperCase(),
            value,
            class: "text-capitalize",
            align: "start",
            sortable: true,
            divider: true,
          };
          if (value === "action") {
            doc.divider = false;
            doc.width = "150px";
          }
          list.push(doc);
        }
        return list;
      } catch (e) {
        console.error('[Form.vue headers] error', e);
        errorLogsWrapper({ module: 'Form.vue headers', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
        return [];
      }
    },
    
    form: {
      get() {
        try {
          let { name, make_id } = this.value;
          if (name === undefined) name = "";
          if (make_id === undefined) make_id = "";
          return [
            {
              value: make_id,
              key: "make_id",
              label: "ID",
              rules: this.rules,
              disabled: false,
              type: "number",
              counter: "",
            },
            {
              value: name,
              key: "name",
              label: "Make",
              rules: this.rules,
              disabled: false,
              type: "text",
              counter: 255,
            },
          ];
        } catch (e) {
          console.error('[Form.vue form] error', e);
          errorLogsWrapper({ module: 'Form.vue form', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
          return [];
        }
      },
    },
    
    filteredList() {
      try {
        return this.list.filter(item => {
          const text = `
            ${item.name}
            ${item.from}
            ${item.to}
            ${item.key_category}
            ${item.app_item_no}
            ${item.type_of_key}
          `.toLowerCase();

          const textMatch = !this.searchChips.length ||
            this.searchChips.every(term => {
              const query = term?.toString().toLowerCase().trim();
              if (!query) return true;
              return text.includes(query);
            });

          const from = Number(item.from);
          const to = Number(item.to);
          const fFrom = this.filterFrom;
          const fTo = this.filterTo;

          let yearMatch = true;

          if (this.exactFrom && fFrom) {
            yearMatch = yearMatch && from === fFrom;
          } else if (fFrom) {
            yearMatch = yearMatch && from >= fFrom;
          }

          if (this.exactTo && fTo) {
            yearMatch = yearMatch && to === fTo;
          } else if (fTo) {
            yearMatch = yearMatch && to <= fTo;
          }

          return textMatch && yearMatch;
        });
      } catch (e) {
        console.error('[Form.vue filteredList] error', e);
        errorLogsWrapper({ module: 'Form.vue filteredList', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { searchChips: this.searchChips, filterFrom: this.filterFrom, filterTo: this.filterTo }, createdBy: auth.currentUser?.email || '-' });
        return this.list || [];
      }
    },
    
    filteredFromYears() {
      try {
        if (!this.filterTo) return this.years;
        return this.years.filter(y => y <= this.filterTo);
      } catch (e) {
        console.error('[Form.vue filteredFromYears] error', e);
        errorLogsWrapper({ module: 'Form.vue filteredFromYears', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { filterTo: this.filterTo }, createdBy: auth.currentUser?.email || '-' });
        return this.years || [];
      }
    },

    filteredToYears() {
      try {
        if (!this.filterFrom) return this.years;
        return this.years.filter(y => y >= this.filterFrom);
      } catch (e) {
        console.error('[Form.vue filteredToYears] error', e);
        errorLogsWrapper({ module: 'Form.vue filteredToYears', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { filterFrom: this.filterFrom }, createdBy: auth.currentUser?.email || '-' });
        return this.years || [];
      }
    }
  },
  
  watch : {
    "$store.getters.serviceFields": {
      deep: true,
      handler(newFields) {
        try {
          const field = newFields.find(f => f.id === fieldsId.KEY_CATEGORY);
          if (field) {
            this.keyCategoryOptions = field.options || [];
          }
        } catch (e) {
          console.error('[Form.vue watch serviceFields] error', e);
          errorLogsWrapper({ module: 'Form.vue watch serviceFields', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { newFieldsLength: newFields?.length }, createdBy: auth.currentUser?.email || '-' });
        }
      }
    },

    "model.mechanical_key"(newValue) {
      try {
        if (newValue === "") {
          this.model.mechanical_key = " ";
          this.$set(this.model, 'mechanical_key', ' ');
        }
      } catch (e) {
        console.error('[Form.vue watch model.mechanical_key] error', e);
        errorLogsWrapper({ module: 'Form.vue watch model.mechanical_key', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { newValue }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    searchChips(val) {
      try {
        if (val && val.length) {
          const uniqueChips = [...new Set(val.map(item => item.toString().trim()))];
          if (uniqueChips.length !== val.length) {
            this.searchChips = uniqueChips;
          }
        }
      } catch (e) {
        console.error('[Form.vue watch searchChips] error', e);
        errorLogsWrapper({ module: 'Form.vue watch searchChips', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { val }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    keyCategoryDialog(val) {
      try {
        if (val && this.model.key_category) {
          const raw = this.model.key_category;
          const existing = (this.keyCategoryOptions || []).find(o => o.value === raw);
          this.keyCategoryChips = [existing || { name: raw, value: raw }];
          this.resetSearchInput();
        }
      } catch (e) {
        console.error('[Form.vue watch keyCategoryDialog] error', e);
        errorLogsWrapper({ module: 'Form.vue watch keyCategoryDialog', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { val, keyCategory: this.model?.key_category }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    filteredKeyCategoryOptions(val) {
      try {
        if (
          this.committedKeyCategorySearchChips.length
          && val.length === 1
          && !this.keyCategoryChips.length
        ) {
          this.selectKeyCategoryOption(val[0]);
        }
      } catch (e) {
        console.error('[Form.vue watch filteredKeyCategoryOptions] error', e);
        errorLogsWrapper({ module: 'Form.vue watch filteredKeyCategoryOptions', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },
  },
  
  methods: {
    resetSearchInput() {
      try {
        this.keyCategorySearch = "";
        this.pendingKeyCategorySearch = "";
        this.pendingKeyCategoryOption = null;
      } catch (e) {
        console.error('[Form.vue resetSearchInput] error', e);
        errorLogsWrapper({ module: 'Form.vue resetSearchInput', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    onKeyCategoryTextInput() {
      try {
        const opt = this.pendingKeyCategoryOption;
        const optLabel = (opt && (opt.name || opt.value) || '').trim().toLowerCase();
        const typed = (this.pendingKeyCategorySearch || '').trim().toLowerCase();
        if (opt && optLabel !== typed) {
          this.pendingKeyCategoryOption = null;
        }
      } catch (e) {
        console.error('[Form.vue onKeyCategoryTextInput] error', e);
        errorLogsWrapper({ module: 'Form.vue onKeyCategoryTextInput', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    clearCommittedSearch() {
      try {
        this.committedKeyCategorySearchChips = [];
        this.pendingKeyCategorySearch = "";
        this.focusKeySearch();
      } catch (e) {
        console.error('[Form.vue clearCommittedSearch] error', e);
        errorLogsWrapper({ module: 'Form.vue clearCommittedSearch', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    isSameAsSelectedKeyCategory(opt) {
      try {
        const currentChip = this.keyCategoryChips[0];
        if (!currentChip) return false;
        const currentValue = (currentChip.value ?? currentChip.name ?? currentChip).toString();
        const optValue = (opt.value ?? opt.name ?? opt).toString();
        return currentValue === optValue;
      } catch (e) {
        console.error('[Form.vue isSameAsSelectedKeyCategory] error', e);
        errorLogsWrapper({ module: 'Form.vue isSameAsSelectedKeyCategory', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { opt }, createdBy: auth.currentUser?.email || '-' });
        return false;
      }
    },

    selectKeyCategoryOption(opt) {
      try {
        if (this.isSameAsSelectedKeyCategory(opt)) return;
        this.keyCategoryChips = [opt];
        this.pendingKeyCategoryOption = null;
        this.pendingKeyCategorySearch = '';
        this.committedKeyCategorySearchChips = [];
        this.keyCategorySearch = '';
        this.focusKeySearch();
      } catch (e) {
        console.error('[Form.vue selectKeyCategoryOption] error', e);
        errorLogsWrapper({ module: 'Form.vue selectKeyCategoryOption', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { opt }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    commitKeyCategorySearch() {
      try {
        const value = (this.pendingKeyCategorySearch || '').trim();
        if (!value) return;

        const valueLower = value.toLowerCase();
        const options = this.keyCategoryOptions || [];
        const opt = this.pendingKeyCategoryOption
          || options.find(o => (o.name || o.value || '').toString().trim() === value)
          || options.find(o => (o.name || o.value || '').toString().trim().toLowerCase() === valueLower);
        const optLabel = (opt && (opt.name || opt.value) || '').trim().toLowerCase();
        if (opt && optLabel === valueLower) {
          if (this.isSameAsSelectedKeyCategory(opt)) {
            this.pendingKeyCategorySearch = '';
            this.pendingKeyCategoryOption = null;
            this.keyCategorySearch = '';
            return;
          }
          this.keyCategoryChips = [opt];
          this.committedKeyCategorySearchChips = [];
          this.pendingKeyCategorySearch = '';
          this.pendingKeyCategoryOption = null;
          this.keyCategorySearch = '';
          return;
        }

        if (this.keyCategoryChips.length) return;

        const normalized = value.toLowerCase();
        const exists = this.committedKeyCategorySearchChips.some(term => term.toLowerCase() === normalized);
        if (!exists) {
          this.committedKeyCategorySearchChips.push(value);
        }
        this.pendingKeyCategorySearch = '';
        this.pendingKeyCategoryOption = null;
      } catch (e) {
        console.error('[Form.vue commitKeyCategorySearch] error', e);
        errorLogsWrapper({ module: 'Form.vue commitKeyCategorySearch', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { pendingSearch: this.pendingKeyCategorySearch }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    removeCommittedKeyCategorySearchChip(index) {
      try {
        this.committedKeyCategorySearchChips.splice(index, 1);
        this.focusKeySearch();
      } catch (e) {
        console.error('[Form.vue removeCommittedKeyCategorySearchChip] error', e);
        errorLogsWrapper({ module: 'Form.vue removeCommittedKeyCategorySearchChip', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { index }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    handleKeyCategoryBackspace(event) {
      try {
        if (!this.pendingKeyCategorySearch) {
          // If a key category is selected, remove that first
          if (this.keyCategoryChips && this.keyCategoryChips.length) {
            this.keyCategoryChips.pop();
            event.preventDefault();
            return;
          }

          // Otherwise remove last committed search chip
          if (this.committedKeyCategorySearchChips && this.committedKeyCategorySearchChips.length) {
            this.committedKeyCategorySearchChips.pop();
            event.preventDefault();
            return;
          }
        }
      } catch (e) {
        console.error('[Form.vue handleKeyCategoryBackspace] error', e);
        errorLogsWrapper({ module: 'Form.vue handleKeyCategoryBackspace', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    focusKeySearch() {
      try {
        this.$nextTick(() => {
          try {
            if (this.$refs.keyCategoryInput) {
              this.$refs.keyCategoryInput.focus();
            }
          } catch (e) {
            console.error('[Form.vue focusKeySearch nextTick] error', e);
            errorLogsWrapper({ module: 'Form.vue focusKeySearch nextTick', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
          }
        });
      } catch (e) {
        console.error('[Form.vue focusKeySearch] error', e);
        errorLogsWrapper({ module: 'Form.vue focusKeySearch', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    copyKeyCategoryOption(opt) {
      try {
        const text = (opt.name || opt.value || '').toString().replace(/\s+/g, ' ').trim();
        if (text) {
          navigator.clipboard.writeText(text);
        }
      } catch (e) {
        console.error('[Form.vue copyKeyCategoryOption] error', e);
        errorLogsWrapper({ module: 'Form.vue copyKeyCategoryOption', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { opt }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    copyKeySearchContent() {
      try {
        const parts = [
          ...this.committedKeyCategorySearchChips,
          ...this.keyCategoryChips.map(chip => chip.name || chip.value || chip),
        ];
        if (this.pendingKeyCategorySearch) {
          parts.push(this.pendingKeyCategorySearch);
        }
        const text = parts.map(part => part.toString().replace(/\s+/g, ' ').trim()).join(", ");
        if (text) {
          navigator.clipboard.writeText(text);
        }
      } catch (e) {
        console.error('[Form.vue copyKeySearchContent] error', e);
        errorLogsWrapper({ module: 'Form.vue copyKeySearchContent', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    removeKeyCategoryChip(index) {
      try {
        this.keyCategoryChips.splice(index, 1);
        this.resetSearchInput();
      } catch (e) {
        console.error('[Form.vue removeKeyCategoryChip] error', e);
        errorLogsWrapper({ module: 'Form.vue removeKeyCategoryChip', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { index }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    cancelKeyCategory() {
      try {
        this.keyCategoryDialog = false;
        this.keyCategoryChips = [];
        this.resetSearchInput();
      } catch (e) {
        console.error('[Form.vue cancelKeyCategory] error', e);
        errorLogsWrapper({ module: 'Form.vue cancelKeyCategory', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },

    selectKeyCategory() {
      try {
        this.model.key_category = this.keyCategoryChips.map(chip => chip.value || chip).join(',');
        this.keyCategoryDialog = false;
        this.keyCategoryChips = [];
        this.resetSearchInput();
        this.keyCategoryJustSelected = true;
      } catch (e) {
        console.error('[Form.vue selectKeyCategory] error', e);
        errorLogsWrapper({ module: 'Form.vue selectKeyCategory', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },
    handleChipClick(uId) {
      try {
        const idx = this.selectedRecordIDs.indexOf(uId);
        if (idx === -1) {
          this.selectedRecordIDs.unshift(uId);
          this.selectedRecordIDs.length =1
        } else {
          this.selectedRecordIDs.splice(idx, 1);
        }
      } catch (e) {
        console.error('[Form.vue handleChipClick] error', e);
        errorLogsWrapper({ module: 'Form.vue handleChipClick', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { uId }, createdBy: auth.currentUser?.email || '-' });
      }
    },
    getRowClass(item) {
      try {
        if (this.selectedRecordIDs.includes(item.uId)) {
          return 'modified-row selected-row';
        }
        if (this.modifedRecordID.includes(item.uId)) {
          return 'modified-row';
        }
        if (item.stock > 0) {
          return 'in-stock-row';
        }
        return '';
      } catch (e) {
        console.error('[Form.vue getRowClass] error', e);
        errorLogsWrapper({ module: 'Form.vue getRowClass', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { itemUId: item?.uId }, createdBy: auth.currentUser?.email || '-' });
        return '';
      }
    },
    onLostCarKeyInput(value) {
      try {
        this.model.lostCarKey = value ? Number(value) : 0.00;
      } catch (e) {
        console.error('[Form.vue onLostCarKeyInput] error', e);
        errorLogsWrapper({ module: 'Form.vue onLostCarKeyInput', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { value }, createdBy: auth.currentUser?.email || '-' });
      }
    },
    openEdit(item, index) {
      try {
        const vm = this;
        vm.beforeEditSnapShot = item;
        vm.index = index;

        vm.currentUId = item.uId;
        Object.keys(item).forEach((key) => {
          vm.$set(vm.model, key, item[key]);
        });

        if(!item.stock){
          vm.$set(vm.model, 'stock', 0);
        }

        let applicableItemString = item.app_item_no || '';
        let mfgSegment = applicableItemString.includes('(') ? applicableItemString.split('(')[1] : '';
        let mfgString = mfgSegment ? mfgSegment.substring(0, mfgSegment.indexOf(')')) : '';
        let findValue = mfgString ? this.mfgOptions.find((opt) => opt?.value?.includes(mfgString)) : undefined;
        if(findValue) {
          item.mfg = findValue.value;
          vm.$set(this.model,'mfg', findValue?.value);
        }
        if(item.mfg == '') {
          let defaultMfg = this.mfgOptions.find((opt) => opt.name.toLowerCase() == 'default');
          vm.$set(this.model,'mfg',defaultMfg?.value)
        }

        fetchCombinedDataEntryLogs(item).then((logs) => {
          vm.combinedDataEntryLogs = logs;
        });

        // if(item.dataEntry == '') {
        //   let users = this.$store.getters.users;
        //   const userName = users.find((i) => i.email == auth.currentUser.email);
        //   item.dataEntry = userName?.name;
        //   this.$set(this.model,'dataEntry', userName?.name);
        // }
      } catch (e) {
        console.error('[Form.vue openEdit] error', e, { app_item_no: item?.app_item_no });
        errorLogsWrapper({ module: 'Form.vue openEdit', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { appItemNo: item?.app_item_no, index }, createdBy: auth.currentUser?.email || '-' });
      }
    },
    isExists(model) {
      try {
        let keys = Object.keys(defaultForm);
        return this.models.findIndex((i) => {
          let results = keys.filter((key) => {
            return (
              model[key] &&
              i[key] &&
              model[key].toString().trim() == i[key].toString().trim()
            );
          });
          return results.length == keys.length;
        });
      } catch (e) {
        console.error('[Form.vue isExists] error', e);
        errorLogsWrapper({ module: 'Form.vue isExists', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { modelUId: model?.uId }, createdBy: auth.currentUser?.email || '-' });
        return -1;
      }
    },
    async add() {
      let vm = this;
      try {
        vm.$refs.form.validate();
        if (!vm.isValid) return;
        // console.log(vm.isExists(vm.model));
        if (vm.isExists(vm.model) != -1) {
          vm.$root.alert("Model already exits");
          return;
        }
        // generated fields must come after the spread, vm.model can still
        // hold uId/createdAt of a previously edited model
        let doc = {
            ...vm.model,
            uId: uuidv4(),
            createdAt: Date.now(),
        };
        delete doc.index;
        delete doc.oldName;
        await vm.generateDataEntryData(doc,'CREATE');
        let id = vm.$route.params.id;
        if(id){
          this.$emit('model-added', doc);
          doc.makeId = id;
          doc.updated_by = auth.currentUser.email
          let users = this.$store.getters.users;
          const userName = users.find((i) => i.email == auth.currentUser.email);
          doc.updatedBy =userName?.name;
          doc.status = 'add'
          await localUpdates.add(doc);
        }
        // else {
        //   vm.models.unshift(doc);
        // }
        vm.models.unshift(doc);
        vm.$refs.form.reset();
        vm.combinedDataEntryLogs = [];

        Object.keys(defaultForm).forEach(key => {
          this.$set(this.model, key, defaultForm[key]);
        });
        vm.$nextTick(() => {
          vm.applyDefaultValues()
        });
        vm.input();
      } catch (e) {
        console.error('[Form.vue add] error', e);
        errorLogsWrapper({ module: 'Form.vue add', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { modelItemNumber: vm.model?.item_number, modelName: vm.model?.name }, createdBy: auth.currentUser?.email || '-' });
        vm.$root.alert && vm.$root.alert("Something went wrong while adding this model. Please try again.");
      }
    },
    saveModalFields() {
      let vm = this;
      try {
        // console.log('----------- form data-----' + vm.$refs.form);
        let doc = {};
        Object.keys(vm.model).forEach((key) => {
          doc[key] = vm.model[key] !== null && vm.model[key] !== undefined ? vm.model[key] : "";
        });

        let arr = ['item_number', 'mfg', 'drawer', 'slot', 'stock']
        let str = '';
        let obj = {
          'item_number' : 'ITEM #',
          'mfg' : '',
          'drawer' : 'DRAWER # (',
          'slot' : 'SLOT (',
          'stock' : '*STOCK: ('
        };

        for(let i = 0; i < arr.length; i++) {

          if(doc[arr[i]] !== '' && doc[arr[i]] !== null && doc[arr[i]] !== undefined){
            if(obj[arr[i]] == 'ITEM #') {
              str += `${obj[arr[i]]} ${doc[arr[i]]} `;
            } else if (arr[i] === 'mfg') {

                if(doc[arr[i]] === 'NONE' || doc[arr[i]] === 'N/A') {
                  let defaultValue = this.mfgOptions.find((opt) => opt.name.toLowerCase() == 'default')
                  defaultValue = defaultValue.value.split('(')[1];
                  str += `(${defaultValue} `;
                } else {
                  let val = doc[arr[i]].split('(')[1] !== undefined ? `${doc[arr[i]].split('(')[1]}` :
                                                                      `${this.mfgOptions.find((opt) => opt.name.toLowerCase() == 'default')
                                                                     .value.split('(')[1]}`;
                  str += `(${val} `;
                }

            } else {
              str += `${obj[arr[i]]}` + doc[arr[i]] + ') ';
            }

          } else if (arr[i] === 'mfg') {

            if(doc[arr[i]] === 'NONE' || doc[arr[i]] === 'N/A') {
                  let defaultValue = this.mfgOptions.find((opt) => opt.name.toLowerCase() == 'default')
                  defaultValue = defaultValue.value.split('(')[1];
                  str += `(${defaultValue} `;
                } else {
                  let val = doc[arr[i]].split('(')[1] !== undefined ? `${doc[arr[i]].split('(')[1]}` :
                                                                     `${this.mfgOptions.find((opt) => opt.name.toLowerCase() == 'default')
                                                                     .value.split('(')[1]}`;
                  str += `(${val} `;
                }
          }else {
            if(obj[arr[i]] == 'ITEM #') {
              str += `${obj[arr[i]]} `;
            } else {
              str += `${obj[arr[i]]}?) `;
            }

          }
        }
        if (vm.keyCategoryJustSelected) {
          // let typeOfKeyValue = this.findMostRelateMatchStringOfTypeOfKey(doc['key_category']);
          // vm.$set(vm.model,'type_of_key', typeOfKeyValue);
          vm.keyCategoryJustSelected = false;
        }
        vm.$set(vm.model, 'key_category', doc['key_category']);
        vm.$set(vm.model,'app_item_no',str);
      } catch (e) {
        console.error('[Form.vue saveModalFields] error', e);
        errorLogsWrapper({ module: 'Form.vue saveModalFields', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { modelItemNumber: vm.model?.item_number }, createdBy: auth.currentUser?.email || '-' });
      }
    },
   async update() {
      let vm = this;
      try {
        vm.$refs.form.validate();
        if (!vm.isValid) return;
        let index = vm.isExists(vm.model);
        if (index != -1 && index != vm.index) {
          vm.$root.alert("Model already exits");
          return;
        }
        // Capture index before any awaits — openEdit() can change vm.index
        // while Firebase calls are in-flight, which would corrupt the wrong row.
        const savedIndex = vm.index;
        let doc = {};
        Object.keys(vm.model).forEach((key) => {
          doc[key] = vm.model[key] ?? "";
        });
        if (!doc.uId) doc.uId = uuidv4();
        await vm.generateDataEntryData(doc,'UPDATE');
        console.log('carmakedoc---------->',doc);
        doc.updatedAt = Date.now();
        let id = vm.$route.params.id;
        if(id){
          // vm.modifedRecordID.push(doc.uId);
          // vm.$set(vm,'modifedRecordID',[...vm.modifedRecordID,doc.uId]);

          this.$emit('model-updated', doc);
          doc.makeId = id;
          doc.updated_by = auth.currentUser.email
          let users = this.$store.getters.users;
          const userName = users.find((i) => i.email == auth.currentUser.email);
          doc.updatedBy =userName?.name;
          doc.status = 'update'

          const latestData =await carMake.doc(id).get();
          latestData.data().models.forEach(dbModel => {
            if(dbModel.uId == doc.uId){
              doc.oldName = dbModel.name;
            }
          });
          // await localUpdates.add(doc);
          // to handel re-updates on same car model before submit
          const snapshot = await localUpdates
            .where("updated_by", "==", doc.updated_by)
            .where("uId", "==", doc.uId)
            .get();

          if (snapshot.empty) {
            await localUpdates.add(doc);
          } else {
            this.$emit('delete-updated-temp', doc);
            const docId = snapshot.docs[0].id;
            await localUpdates.doc(docId).set(doc, { merge: false });
          }
        }
        //  else {
        //    vm.$set(vm.models, savedIndex, doc);
        // }
        vm.$set(vm.models, savedIndex, doc);
        vm.index = -1;
        vm.$refs.form.reset();
        vm.combinedDataEntryLogs = [];
        Object.keys(defaultForm).forEach(key => {
          this.$set(this.model, key, defaultForm[key]);
        });
        vm.$nextTick(() => {
          vm.applyDefaultValues()
        });
        vm.input();
      } catch (e) {
        console.error('[Form.vue update] error', e);
        errorLogsWrapper({ module: 'Form.vue update', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { modelUId: vm.model?.uId, index: vm.index }, createdBy: auth.currentUser?.email || '-' });
        vm.$root.alert && vm.$root.alert("Something went wrong while updating this model. Please try again.");
      }
    },
    remove(index) {
      let vm = this;
      try {
        vm.$confirm.show({
          message: "Are you sure?",
          onConfirm: async () => {
            try {
              let id = vm.$route.params.id;
              if(id){
                this.$emit('model-delete', {uId : vm.models[index].uId, name:vm.models[index].name  });
              }
              let doc = vm.models[index]
              doc.oldName = null
              doc.makeId = id;
              doc.updated_by = auth.currentUser.email
              let users = this.$store.getters.users;
              const userName = users.find((i) => i.email == auth.currentUser.email);
              doc.updatedBy =userName?.name;
              doc.status = 'delete'
              await localUpdates.add(doc);

              vm.input();
              vm.models.splice(index, 1);
              vm.input();
              vm.index = -1;
              vm.model = {
                name: "",
                from: "",
                to: "",
                lostCarKey: 0.00,
              };
            } catch (e) {
              console.error('[Form.vue remove onConfirm] error', e);
              errorLogsWrapper({ module: 'Form.vue remove onConfirm', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { index, itemUId: vm.models?.[index]?.uId }, createdBy: auth.currentUser?.email || '-' });
            }
          },
        });
      } catch (e) {
        console.error('[Form.vue remove] error', e);
        errorLogsWrapper({ module: 'Form.vue remove', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { index }, createdBy: auth.currentUser?.email || '-' });
      }
    },
    input() {
      try {
        let form = {};
        const vm = this;
        vm.form.forEach(({ key, value }) => {
          form[key] = value;
        });
        form.models = vm.models;
        // console.log('form---->',form);

        vm.$emit("input", form);
      } catch (e) {
        console.error('[Form.vue input] error', e);
        errorLogsWrapper({ module: 'Form.vue input', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
      }
    },
    handleUserInput(event) {
      try {
        // Prevent blank spaces when the user deletes everything
        // console.log('on chage', event)
        if (event == "") {
          // console.log('you are inside if')
          this.model.mechanical_key = "  ";
          this.$set(this.model,'mechanical_key', '  ');
        }
      } catch (e) {
        console.error('[Form.vue handleUserInput] error', e);
        errorLogsWrapper({ module: 'Form.vue handleUserInput', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { event }, createdBy: auth.currentUser?.email || '-' });
      }
    },
  findMostRelateMatchStringOfTypeOfKey(keyCategoryValue) {
    try {
      const field = this.$store.getters.serviceFields.find(
        (i) => i.id == customerModal.TYPE_OF_KEY
      );

      const typeOfKey = field?.options.map(opt => opt.name) || [];
      if (!typeOfKey.length) return null;

      const numMatch = keyCategoryValue.match(/\d+/);
      const inputText = keyCategoryValue
        .replace(/\d+/g, '')
        .replace(/[()]/g, '') // Remove ( and )
        .toLowerCase()
        .trim();

      const normalizedOptions = typeOfKey.map(opt =>
        opt.replace(/\d+/g, '')
           .replace(/[()]/g, '')
           .toLowerCase()
           .trim()
      );

      const bestMatch = stringSimilarity.findBestMatch(inputText, normalizedOptions).bestMatch;

      if (bestMatch.rating < 0.3) return null;

      const matchedText = String(bestMatch.target || '').toLowerCase().replaceAll(" ", "");
      const possibleMatches = typeOfKey.filter(opt =>
        opt.replace(/\d+/g, '')
           .replace(/[()]/g, '')
           .replaceAll(" ", "")
           .toLowerCase()
           .trim()
           === matchedText.trim()
      );

      if (numMatch) {
        const number = numMatch[0];
        const finalMatch = possibleMatches.find(opt => {
          return new RegExp(number).test(opt);
        });
        return finalMatch || possibleMatches[0] || null;
      }

      return possibleMatches[0] || null;
    } catch (e) {
      console.error('[Form.vue findMostRelateMatchStringOfTypeOfKey] error', e);
      errorLogsWrapper({ module: 'Form.vue findMostRelateMatchStringOfTypeOfKey', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { keyCategoryValue }, createdBy: auth.currentUser?.email || '-' });
      return null;
    }
  },
  async generateDataEntryData(doc,action) {
    try {
      let users = this.$store.getters.users;
      const userName = users.find((i) => i.email == auth.currentUser.email);
      this.model.dataEntry = userName?.name;
      let dataEntryData = {
        name : userName?.name,
        action : action,
        timeStamp : Date.now()
      }
      // New entries are written to the modelDataEntryLogs collection (one
      // doc per model, keyed by uId) rather than inline on doc.dataEntryLogs.
      await writeDataEntryLog({
        modelUId: doc.uId,
        makeId: this.$route.params.id,
        makeName: this.value?.name,
        modelName: doc.name,
        entry: dataEntryData,
      });
    } catch (e) {
      console.error('[Form.vue generateDataEntryData] error', e);
      errorLogsWrapper({ module: 'Form.vue generateDataEntryData', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { action, docUId: doc?.uId }, createdBy: auth.currentUser?.email || '-' });
    }
  }

  , async duplicate(item) {
    const vm = this;
    if (vm.duplicatingUIds.includes(item.uId)) return;
    vm.duplicatingUIds.push(item.uId);
    try {
      vm.$root.loader = true;
      let { id } = vm.$route.params
      const newItem = JSON.parse(JSON.stringify(item));
      newItem.uId = uuidv4();
      let users = this.$store.getters.users;
      const userName = users.find((i) => i.email == auth.currentUser.email);
      let updatedBy = userName?.name;
      let email = auth.currentUser.email
      let date = getDate();
       //let id = vm.$route.params.id;
      if(id){
        await tempModels.add({makeId : id, data : newItem, createdAt: Date.now(), status: 'add', updatedBy, updated_by :email , updated_at: date});
        } else {
           vm.models.unshift(newItem);
        }
      vm.input();
    } catch (e) {
      console.error('[Form.vue duplicate] error', e);
      errorLogsWrapper({ module: 'Form.vue duplicate', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { itemUId: item?.uId }, createdBy: auth.currentUser?.email || '-' });
    } finally {
      vm.$root.loader = false;
      vm.duplicatingUIds = vm.duplicatingUIds.filter((uId) => uId !== item.uId);
    }
  },
  changeFieldData(models){
    const vm = this;
    try {
      vm.models = models;
      vm.input()
      if(vm.currentUId) {
        vm.models.forEach((model,index) => {
          try {
            if(model.uId == vm.currentUId){
              vm.index=index;
              let flag = vm.checkSomeItem(model);
              if(!flag) {
                  vm.openEdit(model,index);
              }
            }
          } catch (e) {
            console.error('[Form.vue changeFieldData forEach] error', e, { model });
            errorLogsWrapper({ module: 'Form.vue changeFieldData forEach', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { modelUId: model?.uId }, createdBy: auth.currentUser?.email || '-' });
          }
        })
      }
    } catch (e) {
      console.error('[Form.vue changeFieldData] error', e);
      errorLogsWrapper({ module: 'Form.vue changeFieldData', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { modelsLength: models?.length }, createdBy: auth.currentUser?.email || '-' });
    }
  },
  checkSomeItem(item) {
    try {
      let same = true;
      const vm = this;
      if(!vm.beforeEditSnapShot) return same;
      Object.keys(item).forEach(key => {
        if(item[key] != vm.beforeEditSnapShot[key]
        && key != 'uId'
        && key != 'index'
        && key != 'dataEntryLogs') {
          same = false;
        }
      });
      return same;
    } catch (e) {
      console.error('[Form.vue checkSomeItem] error', e);
      errorLogsWrapper({ module: 'Form.vue checkSomeItem', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { itemUId: item?.uId }, createdBy: auth.currentUser?.email || '-' });
      return true;
    }
  },
  retriveTempModel() {
    const vm = this;
    try {
      const {id} = vm.$route.params;

      if(id) {
        tempModels.onSnapshot(sp => {
          try {
            vm.tempRecord = [];
            for(let doc of sp.docs) {
              if(doc.data().makeId == id) {
                vm.tempRecord.push(doc.data());
              }
            }
          } catch (e) {
            console.error('[Form.vue retriveTempModel onSnapshot] error', e);
            errorLogsWrapper({ module: 'Form.vue retriveTempModel onSnapshot', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { routeId: vm.$route?.params?.id }, createdBy: auth.currentUser?.email || '-' });
          }
        })
      }
    } catch (e) {
      console.error('[Form.vue retriveTempModel] error', e);
      errorLogsWrapper({ module: 'Form.vue retriveTempModel', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { routeId: vm.$route?.params?.id }, createdBy: auth.currentUser?.email || '-' });
    }
  },
  // this is to display local temp tabel
  retriveLocalUpdates() {
    const vm = this;
    try {
      const {id} = vm.$route.params;

      if(id) {
        localUpdates.onSnapshot(sp => {
          try {
            vm.localRecord = [];
            vm.modifedRecordID = [];
            for(let doc of sp.docs) {
              if(doc.data().makeId == id) {
                vm.localRecord.push(doc.data());
                vm.$set(vm,'modifedRecordID',[...vm.modifedRecordID,doc.data().uId]);
              }
            }
          } catch (e) {
            console.error('[Form.vue retriveLocalUpdates onSnapshot] error', e);
            errorLogsWrapper({ module: 'Form.vue retriveLocalUpdates onSnapshot', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { routeId: vm.$route?.params?.id }, createdBy: auth.currentUser?.email || '-' });
          }
        })
      }
    } catch (e) {
      console.error('[Form.vue retriveLocalUpdates] error', e);
      errorLogsWrapper({ module: 'Form.vue retriveLocalUpdates', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { routeId: vm.$route?.params?.id }, createdBy: auth.currentUser?.email || '-' });
    }
  },

  // this is to handel local data which already exist at mounting stage
  async setLocalUpdates() {
    const vm = this;
    try {
      const {id} = vm.$route.params;

      if(id) {
        const snapshot = await localUpdates
          .where("makeId", "==", id)
          .where("updated_by", "==", auth.currentUser.email)
          .get();

          if (!snapshot.empty) {
          const batch = fs.batch();
          vm.$confirm.show({
            message: "Do you want to restore your previous updates?",
            onConfirm: () => {
              try {
                snapshot.forEach((doc) => {
                  let data = doc.data()
                  if(data.status == 'update'){
                    this.$emit('model-updated', data);
                  }else if(data.status == 'add'){
                    this.$emit('model-added', data);
                  }else if(data.status == 'delete'){
                    this.$emit('model-delete', data);
                  }
                });
              } catch (e) {
                console.error('[Form.vue setLocalUpdates onConfirm] error', e);
                errorLogsWrapper({ module: 'Form.vue setLocalUpdates onConfirm', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { routeId: vm.$route?.params?.id }, createdBy: auth.currentUser?.email || '-' });
              }
            },
            onCancel: async () => {
              try {
                snapshot.forEach((doc) => {
                batch.delete(doc.ref);
                });
                await batch.commit();
                window.location.reload();
              } catch (e) {
                console.error('[Form.vue setLocalUpdates onCancel] error', e);
                errorLogsWrapper({ module: 'Form.vue setLocalUpdates onCancel', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { routeId: vm.$route?.params?.id }, createdBy: auth.currentUser?.email || '-' });
              }
            }
          });
        }
      }
    } catch (e) {
      console.error('[Form.vue setLocalUpdates] error', e);
      errorLogsWrapper({ module: 'Form.vue setLocalUpdates', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { routeId: vm.$route?.params?.id }, createdBy: auth.currentUser?.email || '-' });
    }
  },

  applyDefaultValues() {
    const vm  = this;
    try {
      let modelKeys = {
            [fieldsId.MFG]: 'mfg',
            [fieldsId.BRAND]: 'brand',
            [fieldsId.CONDITION]: 'condition',
            [fieldsId.BATTERIES]: 'battery_type',
            [fieldsId.REFLASHING]: 'reFlashing',
            [fieldsId.KEY_CATEGORY]: 'key_category',
            [fieldsId.BUTTON]: 'button',
            [fieldsId.TOTAL_TOKENS]: 'tokensNeed',
            [fieldsId.PIN_CODE]: 'pinCode',
            [fieldsId.REUSABLE]: 'reusable',
            [fieldsId.CLONEABLE]: 'cloneable',
            [fieldsId.PROGRAM_REMOTE]: 'programRemote',
            [fieldsId.ADD_KEY]: 'addKey',
            [fieldsId.LISH]: 'lishi',
            [fieldsId.FREQUENCY]: 'frequency',
            [fieldsId.ADDITIONAL_HARDWARE]: 'additionalHardware',
          };
        Object.keys(modelKeys).forEach(fieldId => {
          const field = vm.$store.getters.serviceFields.find(f => f.id === fieldId);

          const options = field?.options || [];
          const defaultObj = options.find(opt => opt.name?.toLowerCase() === 'default');

          if (defaultObj) {
            vm.$set(vm.model, modelKeys[fieldId], defaultObj.value);
          }
        });
    } catch (e) {
      console.error('[Form.vue applyDefaultValues] error', e);
      errorLogsWrapper({ module: 'Form.vue applyDefaultValues', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
    }
  },

  clearFilters() {
    try {
      this.searchChips = [];
      this.filterFrom = null;
      this.filterTo = null;
      this.exactFrom = false;
      this.exactTo = false;
    } catch (e) {
      console.error('[Form.vue clearFilters] error', e);
      errorLogsWrapper({ module: 'Form.vue clearFilters', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
    }
  }
},
  mounted() {
    try {
      EventBus.$on('changeUpdateModelValue',this.changeFieldData)
      this.models = this.value?.models || [];
      this.retriveTempModel();
      this.retriveLocalUpdates();
      this.setLocalUpdates();
      const getServiceFieldOptions = (id) => {
        try {
          const serviceFieldsResult = this.$store.getters.serviceFields.filter(f => f.id == id)[0]?.options || [];

          let keysName = serviceFieldsResult.map(f => f.name);

          let flag = false;
          for(let i = 0; i < keysName.length; i++){
            if(keysName[i].toLowerCase() == 'default') {
              flag = true;
              break;
            }
          }
          if(flag) {
            let modelKeys = {};
            modelKeys[`${fieldsId.MFG}`] = 'mfg';
            modelKeys[`${fieldsId.BRAND}`] = 'brand';
            modelKeys[`${fieldsId.CONDITION}`] = 'condition';
            modelKeys[`${fieldsId.BATTERIES}`] = 'battery_type';
            modelKeys[`${fieldsId.REFLASHING}`] ='reFlashing';
            modelKeys[`${fieldsId.KEY_CATEGORY}`] = 'key_category';
            modelKeys[`${fieldsId.BUTTON}`] = 'button';
            modelKeys[`${fieldsId.TOTAL_TOKENS}`] = 'tokensNeed';
            modelKeys[`${fieldsId.PIN_CODE}`] = 'pinCode';
            modelKeys[`${fieldsId.REUSABLE}`] ='reusable';
            modelKeys[`${fieldsId.CLONEABLE}`] = 'cloneable';
            modelKeys[`${fieldsId.PROGRAM_REMOTE}`] = 'programRemote';
            modelKeys[`${fieldsId.ADD_KEY}`] = 'addKey';
            modelKeys[`${fieldsId.LISH}`] = 'lishi';
            modelKeys[`${fieldsId.FREQUENCY}`] ='frequency';
            modelKeys[`${fieldsId.ADDITIONAL_HARDWARE}`] = 'additionalHardware';

            for(let i = 0; i< serviceFieldsResult.length; i++) {
              let obj = serviceFieldsResult[i];
              if(obj.name.toLowerCase() == 'default') {
                // console.log(obj.value);
               this.$set(this.model,modelKeys[id], obj.value);
                // console.log('you are inside loop');
              }
            }
          }
          return serviceFieldsResult;
        } catch (e) {
          console.error('[Form.vue mounted getServiceFieldOptions] error', e, { id });
          errorLogsWrapper({ module: 'Form.vue mounted getServiceFieldOptions', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, context: { fieldId: id }, createdBy: auth.currentUser?.email || '-' });
          return [];
        }
      };

      this.mfgOptions = getServiceFieldOptions(fieldsId.MFG || "MFG");
      this.brandOptions = getServiceFieldOptions(fieldsId.BRAND ||"BRAND");
      this.conditionOptions = getServiceFieldOptions(fieldsId.CONDITION ||"CONDITION");
      this.batteryOptions = getServiceFieldOptions(fieldsId.BATTERIES || "BATTERIES");
      this.reflashingOptions = getServiceFieldOptions(fieldsId.REFLASHING || "REFLASHING");
      this.keyCategoryOptions = getServiceFieldOptions(fieldsId.KEY_CATEGORY ||"KEY CATEGORY");
      this.buttonOptions = getServiceFieldOptions(fieldsId.BUTTON||"BUTTON");
      this.totalTokensOptions = getServiceFieldOptions(fieldsId.TOTAL_TOKENS || "TOTAL TOKENS");
      this.pinCodeOptions = getServiceFieldOptions(fieldsId.PIN_CODE||"PIN CODE");
      this.reusableOptions = getServiceFieldOptions(fieldsId.REUSABLE||"REUSABLE");
      this.cloneableOptions = getServiceFieldOptions(fieldsId.CLONEABLE ||"CLONEABLE");
      this.programRemoteOptions = getServiceFieldOptions(fieldsId.PROGRAM_REMOTE||"PROGRAM REMOTE");
      this.addKeyOptions = getServiceFieldOptions(fieldsId.ADD_KEY||"ADD KEY");
      this.lishiOptions = getServiceFieldOptions(fieldsId.LISH||"LISH");
      this.frequencyOptions = getServiceFieldOptions(fieldsId.FREQUENCY||"FREQUENCY");
      this.additionalHardwareOptions = getServiceFieldOptions(fieldsId.ADDITIONAL_HARDWARE || "ADDITIONAL HARDWARE");
    } catch (e) {
      console.error('[Form.vue mounted] error', e);
      errorLogsWrapper({ module: 'Form.vue mounted', description: 'error', errorDetails: { message: e?.message || String(e), stack: e?.stack || null }, createdBy: auth.currentUser?.email || '-' });
    }
  }
};
</script>

<style>
.in-stock-row {
  color: #3bab42 !important;
}

.in-stock-row td {
  color: #3bab42 !important;
}

.app-item-selected input,
.app-item-selected .v-text-field__slot input,
.app-item-selected .v-input__slot input {
  color: #1b5e20 !important;
}

.app-item-selected .v-label {
  color: #1b5e20 !important;
}

.no-bottom-class {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}

.no-bottom-class .v-input {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
}

.no-bottom-space {
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
}

.custom-field {
  display: flex;
  align-items: center;
}

.custom-field label{
  overflow: visible !important;
  z-index: 99;
  min-width: fit-content ;
  background-color: white !important;
}


.custom-field .v-input__append-inner{
  width: 100%;
  height: 24px;
}

.vertical-divider {
  width: 2px;
  background-color: black; /* Vertical line */
  margin: 0 10px; /* Spacing */
  height: 32px;
}

.emg-key {
  color: rgba(0, 0, 0, 1); /* Match default text color */
  font-size: 16px; /* Adjust as needed */
  display: flex;
  align-items: center;
  font-weight: 400;
}

.success-checkbox-wrapper {
  border: 1px solid #111010;
  padding: 10px 8px;
  height: 46px;
  box-sizing: border-box;
}

.success-border {
  border-color: #4CAF50 !important;
  background-color: #E8F5E9;
}

.modified-row {
  background-color: #f1ba03 !important; /* light yellow */
}

.selected-row {
  background-color: rgba(0, 255, 0, 0.519) !important;
}

.tag-item {
  display: inline-flex;
  align-items: center;
  background: #1140a5;
  border-radius: 16px;
  padding: 4px 10px;
  margin: 2px;
  font-size: 13px;
}

.clear-btn {
  margin-left: 8px;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
}

.clear-btn:hover {
  color: red;
}

.chip-title {
  color: white;
}

.key-search-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-height: 40px;
  padding: 4px 10px;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  cursor: text;
}

.key-search-box:focus-within {
  border-color: #1976d2;
  border-width: 2px;
}

.key-search-icon {
  margin-right: 2px;
}

.key-search-copy {
  margin-left: 4px;
  cursor: pointer;
}

.key-search-copy:hover {
  color: #1976d2 !important;
}

.key-chip {
  margin: 1px;
  height: auto !important;
  max-width: 100%;
}

.key-chip.v-chip .v-chip__content {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.3;
  padding: 4px 0;
}

.key-option-selected {
  background-color: rgba(25, 118, 210, 0.08);
}

.key-search-input {
  flex: 1;
  min-width: 100px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  padding: 2px 0;
  color: rgba(0, 0, 0, 0.87);
}

.key-search-input::placeholder {
  color: rgba(0, 0, 0, 0.42);
}

</style>
